<template>
    <div>
        <h1 class="display-heading">Manage Permissible ICD 10 Codes</h1>

        <div class="mb-3">
            <div class="mb-2">
                <b>Select Category</b>
            </div>
            <select v-model="currentViewingCategory" class="form-control">
                <option v-for="(item, index) in list" :key="index" :value="item.id">
                    {{ item.name }}
                </option>
            </select>
        </div>

        <template v-if="currentCategory && currentCategory.permissibles">
            <div v-for="(item, index) in currentCategory.permissibles" :key="index" class="card mb-3">
                <div class="card-header">
                    {{ item.name }}
                </div>
                <div class="card-body">
                    <div class="mb-3">
                        <p>
                            <b>Current</b>
                        </p>
                    </div>
                    <div v-if="item.icd10Codes.length > 0" class="d-flex flex-wrap">
                        <div v-for="(icdCode, index) in item.icd10Codes" :key="index" class="existing-icd10code mr-2 mb-2">
                            {{ icdCode.icd10Code }}
                        </div>
                    </div>
                    <div v-else>
                        <p class="font-italic">No ICD 10 Codes Selected...</p>
                    </div>
                    <hr>
                    <div class="mb-3">
                        <p>
                            <b>
                                Add New (Press Enter to Add New, Split Multiple Codes by Space)
                            </b>
                        </p>
                        <div class="mb-3">
                            <input class="form-control" @keyup.enter="(e)=>{ insertIcd10Code(item.id, e)}" />
                        </div>
                        <div v-if="getNewListForPermissible(item.id) !== null && getNewListForPermissible(item.id).items.length > 0">
                            <div class="d-flex flex-wrap">
                                <div v-for="(newCode, index) in getNewListForPermissible(item.id).items" :key="index" class="d-flex existing-icd10code align-items-center mr-2 mb-2">
                                    <div class="mr-2">
                                        <p>
                                            {{ newCode }}
                                        </p>
                                    </div>
                                    <button type="button" class="btn btn-danger" @click="deleteNewCode(item.id, index)">
                                        <i class="fas fa-trash-alt"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <p class="font-italic">No ICD 10 Codes Selected...</p>
                        </div>
                    </div>

                    <button type="button" class="btn btn-primary btn-primary-insv mr-2" @click="submitCodes(item.id)">Save Changes</button>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    'name': 'AdminManagePermissibleAndIcd10Codes',
    mounted () {
        this.getList();
    },
    'computed': {
        currentCategory () {
            const current = this.list.find(l => l.id === this.currentViewingCategory);

            if (current) {
                return current;
            }

            return {};
        }
    },
    data () {
        return {
            'list': [],
            'currentViewingCategory': '',
            'listNew': []
        };
    },
    'methods': {
        getList () {
            this.axios.get('Permissible/Admin/GetAll').then(({ data }) => {
                const list = data.data;
                if (list) {
                    this.list = data.data;

                    if (!this.currentViewingCategory) {
                        this.currentViewingCategory = this.list[0].id;
                    }
                }
            });
        },
        insertIcd10Code (permissibleId, event) {
            const value = event.target.value;
            let valueSplit = value.split(' ');

            valueSplit.forEach(input => {
                input = input.trim();
            });

            valueSplit = valueSplit.filter(v => v.length > 0);

            let existingList = this.listNew.find(n => n.categoryId === this.currentViewingCategory && n.permissibleId === permissibleId);

            if (existingList) {
                valueSplit.forEach(item => {
                    existingList.items.push(item);
                });
            } else {
                this.listNew.push({
                    'categoryId': this.currentViewingCategory,
                    'permissibleId': permissibleId,
                    'items': valueSplit
                });
            }

            event.target.value = '';
        },
        getNewListForPermissible (permissibleId) {
            let item = this.listNew.find(i => i.categoryId === this.currentViewingCategory && i.permissibleId === permissibleId);

            return item || null;
        },
        deleteNewCode (permissibleId, index) {
            let item = this.listNew.find(i => i.categoryId === this.currentViewingCategory && i.permissibleId === permissibleId);

            if (item && item.items) {
                item.items.splice(index, 1);
            }
        },
        submitCodes (permissibleId) {
            let item = this.listNew.find(i => i.categoryId === this.currentViewingCategory && i.permissibleId === permissibleId);

            if (item && item.items && item.items.length > 0) {
                this.axios.post('Permissible/Admin/UpdatePermissible', {
                    'permissibleCategoryId': this.currentViewingCategory,
                    'permissibleId': permissibleId,
                    'icd10Codes': item.items
                }).then(() => {
                    item.items = [];
                    this.getList();
                });
            }
        }
    }
};
</script>

<style>
.existing-icd10code{
    padding: 5px 10px;
    border: 1px solid #000;
}
</style>
